import mutations from './occupationHealthEmployee.mutations'
import actions from './occupationHealthEmployee.actions'
import getters from './occupationHealthEmployee.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}